// Card for a single use case on the /use-cases index.
//
// Layout (top → bottom): thumbnail → headline → description → workflow tags.
// Designed to tile cleanly in a 1–3 column grid as the catalogue grows.
import { Link } from "react-router";

import type { UseCase } from "./use-cases";

export function UseCaseCard({ useCase }: { useCase: UseCase }) {
  return (
    <Link
      to={useCase.href}
      className="group flex h-full flex-col overflow-hidden rounded-[24px] border border-grindigo-100 bg-white no-underline shadow-[0_4px_16px_-8px_rgba(99,102,241,0.18)] transition-[transform,box-shadow,border-color] duration-200 ease-[ease] hover:-translate-y-px hover:border-indigo-200 hover:shadow-[0_18px_40px_-16px_rgba(99,102,241,0.35)]"
    >
      {useCase.thumbnailSrc && (
        <div className="aspect-[16/9] w-full overflow-hidden bg-[#E5E2F4]">
          <img
            src={useCase.thumbnailSrc}
            alt={useCase.thumbnailAlt ?? useCase.headline}
            className="block h-full w-full object-cover transition-transform duration-300 ease-[ease] group-hover:scale-[1.02]"
          />
        </div>
      )}
      <div className="flex flex-1 flex-col p-7">
        <h3 className="font-companion mb-3 text-[clamp(22px,2.4vw,26px)] font-bold leading-[1.2] tracking-[-0.02em] text-primary [text-wrap:balance] group-hover:text-indigo-700">
          {useCase.headline}
        </h3>

        <p className="mb-5 font-body text-[15px] leading-[1.6] text-secondary [text-wrap:pretty]">
          {useCase.description}
        </p>

        <ul className="mt-auto flex flex-wrap gap-1.5">
          {useCase.workflowTags.map((tag) => (
            <li
              key={tag}
              className="inline-flex items-center rounded-full border border-grindigo-100 bg-[#FAFAFE] px-2.5 py-1 text-[12px] font-medium text-grindigo-800"
            >
              {tag}
            </li>
          ))}
        </ul>
      </div>
    </Link>
  );
}
